if (!window.Eurus.loadedScript.has('product-list.js')) {
  window.Eurus.loadedScript.add('product-list.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductsList', () => ({
        errorMessage: false,
        loading: false,

        async handleAddToCart(el, containerQuery, formQuery, name_edt) {
          const container = el.closest(containerQuery);
          if (!container) return;

          const productFormEls = container.querySelectorAll(formQuery);
          const items = [];

          let hasMissingVariant = false;
          let firstMissingSelect = null;

          // Validate + build items
          productFormEls.forEach((formEl) => {
            const productIdInput = formEl.querySelector('.product-id');
            const productId = productIdInput?.value || '';

            const selectEl = formEl.querySelector('.shoplook-variant-select');

            // If dropdown exists, require selection (hidden .product-id must be set)
            if (selectEl && !productId) {
              hasMissingVariant = true;
              if (!firstMissingSelect) firstMissingSelect = selectEl;

              const err = formEl.querySelector('.shoplook-error');
              if (err) err.classList.remove('hidden');

              selectEl.classList.add('border-red-500');
              return; // skip building this item
            }

            // Clean up visual state if valid
            if (selectEl) selectEl.classList.remove('border-red-500');

            // Guard: if still no productId (shouldn't happen), skip
            if (!productId) return;

            // EDT / preorder properties
            let shippingMessage = '';
            const edtElement = formEl.querySelector(`.hidden.cart-edt-properties-${productId}`);
            if (edtElement) {
              shippingMessage = edtElement.value.replace(
                'time_to_cut_off',
                Alpine.store('xEstimateDelivery').noti
              );
            }

            let preorderMessage = '';
            const preorderElement = formEl.querySelector('.hidden.preorder-edt-properties');
            if (preorderElement) preorderMessage = preorderElement.value;

            const properties = {
              ...(name_edt && shippingMessage && { [name_edt]: shippingMessage }),
              ...(preorderMessage && { Preorder: preorderMessage }),
            };

            items.push({
              id: productId,
              quantity: 1,
              properties,
            });
          });

          // Stop if any missing size/variant
          if (hasMissingVariant) {
            this.loading = false;

            if (firstMissingSelect) {
              firstMissingSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
              firstMissingSelect.focus();
            }
            return;
          }

          // Nothing to add (safety)
          if (!items.length) return;

          this.loading = true;
          await Alpine.store('xCartHelper').waitForCartUpdate();
          window.updatingCart = true;

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items,
              sections: Alpine.store('xCartHelper')
                .getSectionsToRender()
                .map((section) => section.id),
            }),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status === 422 || response.status === '422') {
                // NOTE: your original code references `sectionId` which must exist in scope.
                // If it doesn't, this will error. Leaving your logic intact otherwise.
                const error_message = el
                  .closest(`.add-all-container-${sectionId}`)
                  ?.querySelector('.cart-warning');

                this.errorMessage = true;
                if (error_message) error_message.textContent = response.description;

                this.loading = false;
                window.updatingCart = false;
                return;
              }

              window.updatingCart = false;
              this.errorMessage = false;
              this.loading = false;

              Alpine.store('xCartHelper').reRenderSections(response.sections);

              if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                Alpine.store('xQuickView').show = false;
              }

              Alpine.store('xPopup').close();

              if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                Alpine.store('xCartNoti').setItem(response);
              } else {
                Alpine.store('xMiniCart').openCart();
                document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
              }

              const bubbleCount = document.querySelector('#cart-icon-bubble span')?.innerHTML;
              if (bubbleCount) {
                Alpine.store('xCartHelper').currentItemCount = parseInt(bubbleCount, 10);
              }

              document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            })
            .catch(() => {
              window.updatingCart = false;
              this.loading = false;
              this.errorMessage = true;
            });
        },
      }));
    });
  });
}